import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  keywords?: string;
  children?: React.ReactNode;
}
export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/j38SAssrtskzGcKewqUYrE/Veranova_Logo.png',
  ogType = 'website',
  keywords,
  children
}) => {
  const siteUrl = 'https://veranovaklussen.nl';
  const fullUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  return <Helmet data-id="element-1503">
      <title data-id="element-1504">{title}</title>
      <meta name="description" content={description} data-id="element-1505" />
      {keywords && <meta name="keywords" content={keywords} data-id="element-1506" />}
      <link rel="canonical" href={fullUrl} data-id="element-1507" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-1508" />
      <meta property="og:url" content={fullUrl} data-id="element-1509" />
      <meta property="og:title" content={title} data-id="element-1510" />
      <meta property="og:description" content={description} data-id="element-1511" />
      <meta property="og:image" content={ogImage} data-id="element-1512" />
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-1513" />
      <meta property="twitter:url" content={fullUrl} data-id="element-1514" />
      <meta property="twitter:title" content={title} data-id="element-1515" />
      <meta property="twitter:description" content={description} data-id="element-1516" />
      <meta property="twitter:image" content={ogImage} data-id="element-1517" />
      {children}
    </Helmet>;
};